import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { patch } from "../../lib/request"

function normalizeSendForApprovalPostIds(arg) {
  const raw = Array.isArray(arg)
    ? arg
    : Array.isArray(arg?.postIds)
      ? arg.postIds
      : []
  const normalized = raw
    .map((id) => {
      if (id == null || id === "") return null
      if (typeof id === "string" && /^\d+$/.test(id.trim())) return Number(id.trim())
      const n = Number(id)
      return Number.isFinite(n) ? n : null
    })
    .filter((id) => id != null)
  return [...new Set(normalized)]
}

export const sendTopicsForApproval = createAsyncThunk(
  "approval/sendTopicsForApproval",
  async (arg, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const token = state.auth?.token

      if (!token) {
        throw new Error("Authentication required. Please login first.")
      }

      const postIds = normalizeSendForApprovalPostIds(arg)
      if (!postIds.length) {
        throw new Error("Post IDs are required")
      }

      const params = new URLSearchParams()
      postIds.forEach((id) => params.append("postIds", String(id)))

      const endpoint = `posts/send-for-approval?${params.toString()}`
      const response = await patch(endpoint)

      return { response, postIds }
    } catch (error) {
      return rejectWithValue(error.message || "Failed to send posts for approval")
    }
  },
)


const approvalSlice = createSlice({
  name: "approval",
  initialState: {
    sendForApprovalStatus: "idle", // idle | loading | succeeded | failed
    sendForApprovalError: null,
    approvedTopicIds: [],
  },
  reducers: {
    clearApprovalError: (state) => {
      state.sendForApprovalError = null
    },
    clearApprovedTopicIds: (state) => {
      state.approvedTopicIds = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendTopicsForApproval.pending, (state) => {
        state.sendForApprovalStatus = "loading"
        state.sendForApprovalError = null
      })
      .addCase(sendTopicsForApproval.fulfilled, (state, action) => {
        state.sendForApprovalStatus = "succeeded"
        state.sendForApprovalError = null
        state.approvedTopicIds = action.payload.postIds
      })
      .addCase(sendTopicsForApproval.rejected, (state, action) => {
        state.sendForApprovalStatus = "failed"
        state.sendForApprovalError = action.payload
      })
  },
})

export const { clearApprovalError, clearApprovedTopicIds } = approvalSlice.actions
export default approvalSlice.reducer
